import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="Footer">
      <p>Developed By Aparna Pandey</p>
    </div>
  );
};

export default Footer;
